import { createNextTableContext } from '@core/table';

export const TinyDeclarationTableContext = createNextTableContext();
